import { render } from "./sampling-modal.vue?vue&type=template&id=310c21f6"
import script from "./sampling-modal.vue?vue&type=script&lang=js"
export * from "./sampling-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__